import { Theme } from '@mui/material/styles';

export const styles = {
  alert: {
    position: 'absolute',
    top: (theme: Theme) => ({
      md: theme.appNotificationHeightLargeDevice,
      xs: theme.appNotificationHeightSmallDevice,
    }),
    width: '100%',
  },
};
